export const AdminLocksTab = {
  LOCKS: "locks",
  GATEWAYS: "gateways",
  PROXIES: "proxies",
} as const;

export type AdminLocksTabValue =
  (typeof AdminLocksTab)[keyof typeof AdminLocksTab];

export const ProxyScope = {
  TENANT: "tenant",
  ALL: "all",
} as const;

export type ProxyScopeValue = (typeof ProxyScope)[keyof typeof ProxyScope];
